export default __webpack_public_path__ + "static/media/Economics_01_07.ef3288d7.png";